'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.INVALIDATE_TOKEN = exports.CLOSE_ALL_MENUS = exports.TOGGLE_MOBILE_PROFILE_VISIBILITY = exports.TOGGLE_MOBILE_MENU = exports.TOGGLE_SETTINGS_DROPDOWN = exports.TOGGLE_PROFILE_DROPDOWN = undefined;

var _doctifyUtils = require('doctify-utils');

var TOGGLE_PROFILE_DROPDOWN = exports.TOGGLE_PROFILE_DROPDOWN = 'TOPNAV:TOGGLE_PROFILE_DROPDOWN';

var TOGGLE_SETTINGS_DROPDOWN = exports.TOGGLE_SETTINGS_DROPDOWN = 'TOPNAV:TOGGLE_SETTINGS_DROPDOWN';
var TOGGLE_MOBILE_MENU = exports.TOGGLE_MOBILE_MENU = 'TOPNAV:TOGGLE_MOBILE_MENU';
var TOGGLE_MOBILE_PROFILE_VISIBILITY = exports.TOGGLE_MOBILE_PROFILE_VISIBILITY = 'TOPNAV:TOGGLE_MOBILE_PROFILE_VISIBILITY';
var CLOSE_ALL_MENUS = exports.CLOSE_ALL_MENUS = 'TOPNAV:CLOSE_ALL_MENUS';
var INVALIDATE_TOKEN = exports.INVALIDATE_TOKEN = 'TOPNAV:INVALIDATE_TOKEN';

var TopNavActions = {
	closeModal: function closeModal() {
		return { type: CLOSE_ALL_MENUS };
	},
	toggleProfileDropdown: function toggleProfileDropdown() {
		return { type: TOGGLE_PROFILE_DROPDOWN };
	},
	toggleSettingsDropdown: function toggleSettingsDropdown() {
		return { type: TOGGLE_SETTINGS_DROPDOWN };
	},
	toggleMobileMenu: function toggleMobileMenu() {
		return { type: TOGGLE_MOBILE_MENU };
	},
	toggleMobileProfileVisibility: function toggleMobileProfileVisibility() {
		return { type: TOGGLE_MOBILE_PROFILE_VISIBILITY };
	},
	invalidateToken: function invalidateToken(auth, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'auth/logout',
			method: 'GET',
			actionType: INVALIDATE_TOKEN,
			xhrConfig: xhrConfig,
			auth: auth
		});
	}
};

exports.default = TopNavActions;